import { Component, Input, OnChanges } from '@angular/core';
import { PitchPlaylistQuery } from '../shared/pitch-playlist/state';
import { UserDivision } from '../shared/types';

@Component({
  selector: 'pitch-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnChanges {
  @Input() pitch;
  @Input() userDivision: UserDivision = UserDivision.WMG;

  isWCM: boolean = false;

  pitchExpired$ = this.query.selectPitchExpired$;

  constructor(private query: PitchPlaylistQuery) {}

  ngOnChanges(): void {
    this.isWCM = this.userDivision === UserDivision.WCM;
  }
}
